import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
import { object, string, bool, node, oneOf } from 'prop-types';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';

var styles = function styles(_ref) {
  var breakpoints = _ref.breakpoints,
      palette = _ref.palette,
      spacing = _ref.spacing,
      mixins = _ref.mixins;
  return {
    root: {},
    nonInsetContainer: _objectSpread({}, mixins.edgeToEdgeMobileContent(), _defineProperty({
      borderTop: '5px solid transparent'
    }, breakpoints.up('sm'), {
      borderTop: 'none',
      borderLeft: '5px solid transparent'
    })),
    bannerContainer: _objectSpread({}, mixins.flex('center', 'space-between'), _defineProperty({
      padding: spacing(0, 2),
      flexDirection: 'column'
    }, breakpoints.up('sm'), {
      padding: spacing(0, 3),
      flexDirection: 'row'
    })),
    contentContainer: _objectSpread({}, mixins.flex('center'), _defineProperty({
      padding: spacing(2, 0),
      minHeight: 70,
      flexDirection: 'column',
      boxSizing: 'border-box',
      textAlign: 'center',
      maxWidth: 720,
      '& > *': {
        marginBottom: spacing(1)
      },
      '& > *:last-child': {
        marginBottom: 0
      }
    }, breakpoints.up('sm'), {
      padding: spacing(3, 0),
      flexDirection: 'row',
      textAlign: 'left',
      '& > *': {
        marginBottom: 0,
        marginRight: spacing(2)
      },
      '& > *:last-child': {
        marginBottom: 0,
        marginRight: 0
      }
    })),
    insetContainer: _defineProperty({}, breakpoints.up('sm'), {
      padding: spacing(2, 0)
    }),
    buttonContainer: _objectSpread({}, mixins.flex('center'), _defineProperty({
      marginBottom: spacing(1)
    }, breakpoints.up('sm'), {
      marginBottom: 0,
      marginLeft: spacing(1)
    })),
    warnAlert: {
      borderColor: palette.warn.main
    },
    errorAlert: {
      borderColor: palette.error.main
    },
    infoAlert: {
      borderColor: palette.primary.main
    },
    successAlert: {
      borderColor: palette.success.main
    },
    infoInsetAlert: {
      backgroundColor: palette.grey[50]
    },
    errorInsetAlert: {
      backgroundColor: palette.error.extraLight
    },
    warnInsetAlert: {
      backgroundColor: palette.warn.extraLight
    },
    successInsetAlert: {
      backgroundColor: palette.success.extraLight
    },
    dividerTop: {
      borderTop: "1px solid ".concat(palette.divider)
    },
    dividerBottom: {
      borderBottom: "1px solid ".concat(palette.divider)
    }
  };
}; // eslint-disable-next-line prefer-arrow-callback


export var Banner = React.forwardRef(function Banner(props, ref) {
  var _classNames;

  var animate = props.animate,
      buttons = props.buttons,
      dividerBottom = props.dividerBottom,
      classes = props.classes,
      className = props.className,
      content = props.content,
      inset = props.inset,
      open = props.open,
      PaperProps = props.PaperProps,
      state = props.state,
      dividerTop = props.dividerTop;
  var rootClasses = classNames(classes.root, className, (_classNames = {}, _defineProperty(_classNames, classes.nonInsetContainer, !inset && open), _defineProperty(_classNames, classes.dividerTop, dividerTop && open), _defineProperty(_classNames, classes.dividerBottom, dividerBottom && open), _defineProperty(_classNames, classes.warnAlert, state === 'warn'), _defineProperty(_classNames, classes.warnInsetAlert, inset && state === 'warn'), _defineProperty(_classNames, classes.errorAlert, state === 'error'), _defineProperty(_classNames, classes.errorInsetAlert, inset && state === 'error'), _defineProperty(_classNames, classes.infoAlert, state === 'info'), _defineProperty(_classNames, classes.infoInsetAlert, inset && state === 'info'), _defineProperty(_classNames, classes.successAlert, state === 'success'), _defineProperty(_classNames, classes.successInsetAlert, inset && state === 'success'), _classNames));
  var contentContainerClasses = classNames(classes.contentContainer, _defineProperty({}, classes.insetContainer, inset));
  return React.createElement(Paper, _extends({
    classes: {
      root: rootClasses
    },
    elevation: inset ? 0 : 2,
    square: inset,
    ref: ref
  }, PaperProps), React.createElement(Collapse, {
    in: open,
    timeout: animate ? 'auto' : 0
  }, React.createElement("div", {
    className: classes.bannerContainer
  }, React.createElement("div", {
    className: contentContainerClasses
  }, content), buttons && React.createElement("div", {
    className: classes.buttonContainer
  }, buttons))));
});
process.env.NODE_ENV !== "production" ? Banner.propTypes = {
  classes: object.isRequired,
  PaperProps: object,
  animate: bool,
  buttons: node,
  className: string,
  content: node,
  dividerBottom: bool,
  dividerTop: bool,
  inset: bool,
  open: bool,
  state: oneOf(['info', 'success', 'warn', 'error'])
} : void 0;
Banner.defaultProps = {
  animate: false,
  buttons: null,
  className: null,
  content: null,
  inset: false,
  dividerBottom: false,
  dividerTop: false,
  open: true,
  PaperProps: null,
  state: null
};
export default withStyles(styles, {
  name: 'Banner'
})(Banner);